import React from "react";

import CheckoutButton from "../../../CheckoutButton/CheckoutButton";
import { useExpressInterestContext } from "../../../CheckoutExpressInterestContextProider";
import { IExpressInterestButton } from "./ExpressInterestButton.interface";

const ExpressInterestButton = (props: IExpressInterestButton) => {
    const { type, onClick } = props;

    const { formTypeName } = useExpressInterestContext();

    return (
        <CheckoutButton
            type={type}
            onClick={onClick}
            className="d-flex align-items-center justify-content-center"
        >
            {formTypeName}
        </CheckoutButton>
    );
};

export default ExpressInterestButton;
